module.exports = __webpack_public_path__ + "img/resource-ky-active.c9b1dca8.png";